(() => {
  if (window.womanellaFavoritesReady) return;
  window.womanellaFavoritesReady = true;
  const key = 'womanella:favorites:v1';
  let memory = [], dialog, trigger, refreshVersion = 0;
  const valid = item => item && /^\d+$/.test(String(item.id)) && typeof item.handle === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(item.handle);
  const clean = value => Array.isArray(value) ? [...new Map(value.filter(valid).slice(0,200).map(x => [String(x.id), {...x,id:String(x.id)}])).values()] : [];
  const load = () => { try { memory = clean(JSON.parse(localStorage.getItem(key) || '[]')); } catch (_) {} return memory; };
  const say = text => { const status = document.querySelector('[data-favorites-status]'); if (status) status.textContent = text; };
  const persist = () => { try { localStorage.setItem(key, JSON.stringify(memory)); return true; } catch (_) { say(dialog?.dataset.storageError || ''); return false; } };
  const root = () => { const path = dialog?.dataset.root || '/'; return path.endsWith('/') ? path : path + '/'; };
  const urlFor = item => root() + 'products/' + encodeURIComponent(item.handle);
  const make = (tag, className, text) => { const node = document.createElement(tag); if (className) node.className = className; if (text != null) node.textContent = text; return node; };
  const money = value => { try { return new Intl.NumberFormat(dialog.dataset.locale,{style:'currency',currency:dialog.dataset.currency || 'EUR'}).format((Number(value)||0)/100); } catch (_) { return ((Number(value)||0)/100).toFixed(2); } };
  const sync = () => {
    const ids = new Set(memory.map(x => String(x.id)));
    document.querySelectorAll('[data-favorite-toggle]').forEach(button => {
      const active = ids.has(button.dataset.favoriteId);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? button.dataset.favoriteRemoveLabel : button.dataset.favoriteAddLabel);
    });
    document.querySelectorAll('[data-favorites-count]').forEach(node => { node.textContent = String(memory.length); node.hidden = !memory.length; });
  };
  const render = () => {
    if (!dialog) return;
    const body = dialog.querySelector('[data-favorites-body]');
    body.replaceChildren();
    if (!memory.length) { body.append(make('p','womanella-favorites__empty',dialog.dataset.empty)); return; }
    const list = make('ul','womanella-favorites__list');
    memory.forEach(item => {
      const li = make('li','womanella-favorites__item');
      const imageLink = make('a','womanella-favorites__image');
      imageLink.href = urlFor(item); imageLink.setAttribute('aria-label',String(item.title || ''));
      if (typeof item.image === 'string' && item.image) {
        try { const imageUrl = new URL(item.image,location.origin); if (imageUrl.protocol === 'https:' || imageUrl.protocol === 'http:') {
          const img = make('img'); img.src = imageUrl.href; img.alt = ''; img.width=100; img.height=125; img.loading='lazy'; imageLink.append(img);
        } } catch (_) {}
      }
      const info = make('div','womanella-favorites__details');
      const name = make('a','womanella-favorites__name',String(item.title || item.handle)); name.href=urlFor(item);
      info.append(name,make('p','womanella-favorites__price',money(item.price)));
      if (item.available === false) info.append(make('span','womanella-favorites__sold-out',dialog.dataset.soldOut));
      const view = make('a','womanella-favorites__view',dialog.dataset.view); view.href=urlFor(item);
      const remove = make('button','womanella-favorites__remove',dialog.dataset.remove); remove.type='button'; remove.dataset.favoriteRemove=item.id; remove.setAttribute('aria-label',dialog.dataset.remove + ': ' + String(item.title || ''));
      info.append(view,remove); li.append(imageLink,info); list.append(li);
    });
    body.append(list);
  };
  const refresh = async () => {
    const version = ++refreshVersion, snapshot = [...memory], updates = new Map();
    let index=0;
    await Promise.all(Array.from({length:Math.min(4,snapshot.length)},async () => {
      while (index < snapshot.length) {
        const item=snapshot[index++];
        try {
          const response=await fetch(urlFor(item)+'.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
          if (!response.ok) continue;
          const data=await response.json();
          if (String(data.id)!==item.id) continue;
          updates.set(item.id,{title:data.title,price:data.price,image:data.featured_image || '',available:data.available});
        } catch (_) {}
      }
    }));
    if (version !== refreshVersion) return;
    memory=memory.map(item=>({...item,...updates.get(item.id)}));
    persist(); sync(); if (dialog?.open) render();
  };
  const close = () => { if (dialog?.open) dialog.close(); };
  const boot = () => {
    dialog=document.querySelector('[data-favorites-dialog]');
    load(); sync();
    if (dialog && !dialog.dataset.bound) {
      dialog.dataset.bound='true';
      dialog.addEventListener('close',()=>{ document.documentElement.classList.remove('womanella-favorites-open'); trigger?.focus(); });
      dialog.addEventListener('click',event=>{ if(event.target!==dialog)return; const box=dialog.getBoundingClientRect(); if(event.clientX<box.left || event.clientX>box.right || event.clientY<box.top || event.clientY>box.bottom)close(); });
    }
  };
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-favorite-toggle]');
    if (button) {
      event.preventDefault(); event.stopPropagation(); load();
      const id=button.dataset.favoriteId, existing=memory.some(x=>x.id===id);
      if(existing) memory=memory.filter(x=>x.id!==id);
      else {
        const item={id,handle:button.dataset.favoriteHandle,title:button.dataset.favoriteTitle,image:button.dataset.favoriteImage,price:Number(button.dataset.favoritePrice),available:button.dataset.favoriteAvailable==='true'};
        if(!valid(item)) return;
        memory.push(item);
      }
      if(persist())say(existing?dialog?.dataset.removed:dialog?.dataset.added);
      sync(); if(dialog?.open)render(); return;
    }
    const opener=event.target.closest('[data-favorites-open]');
    if(opener && dialog) { event.preventDefault(); trigger=opener; load(); render(); dialog.showModal(); document.documentElement.classList.add('womanella-favorites-open'); refresh(); return; }
    if(event.target.closest('[data-favorites-close]')) { close(); return; }
    const remove=event.target.closest('[data-favorite-remove]');
    if(remove) { const buttons=[...dialog.querySelectorAll('[data-favorite-remove]')],index=buttons.indexOf(remove); memory=memory.filter(x=>x.id!==remove.dataset.favoriteRemove); persist(); sync(); render(); const remaining=dialog.querySelectorAll('[data-favorite-remove]'); (remaining[Math.min(index,remaining.length-1)] || dialog.querySelector('[data-favorites-close]')).focus(); }
  });
  window.addEventListener('storage',event=>{if(event.key===key || event.key===null){load();sync();if(dialog?.open)render();}});
  document.addEventListener('shopify:section:load',boot);
  const observer=new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1 && (n.matches?.('[data-favorite-toggle]') || n.querySelector?.('[data-favorite-toggle]')))))sync();});
  const ready=()=>{boot();observer.observe(document.body,{childList:true,subtree:true});};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
})();